import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({
    selector: 'app-e-tds',
    templateUrl: './e-tds.component.html',
    styleUrls: ['./e-tds.component.css'],
    standalone: false
})
export class ETdsComponent implements OnInit {

  constructor(private router:Router) { }

  ngOnInit(): void {


  }

  onBacktoMainPage() {
    this.router.navigate(["/landing-page"]);
  }

}
